import { QuestionTypeEnum } from "src/app/shared/interfaces/process-config.interface";


export class QuestionAvailability {
    enabled: boolean;
    hidden: boolean;
}

export class QuestionTypeAvailabilityFeature {
    question: Record<QuestionTypeEnum, QuestionAvailability> = {
        [QuestionTypeEnum.Text]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Boolean]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Slider]: { enabled: true, hidden: false },
        [QuestionTypeEnum.GroupedSlider]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Selection]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Date]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Number]: { enabled: true, hidden: false },
        [QuestionTypeEnum.MultiSelection]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Weight]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Description]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Title]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Deadline]: { enabled: true, hidden: false },
        [QuestionTypeEnum.InitialDeadline]: { enabled: true, hidden: false },
        [QuestionTypeEnum.Calculate]: { enabled: true, hidden: false }
    };

    constructor(questionTypeAvailabilities: Partial<Record<QuestionTypeEnum, QuestionAvailability>> = null) {
        if (questionTypeAvailabilities) {
            this.question = {
                ...this.question,
                ...(questionTypeAvailabilities || {})
            };
        }

    }
}